export const UPDATE_SEARCH_LOADER = 'UPDATE_SEARCH_LOADER'
export const UPDATE_SEARCH_RESULT = 'UPDATE_SEARCH_RESULT'
export const UPDATE_ADVANCED_SEARCH_MODAL = 'UPDATE_ADVANCED_SEARCH_MODAL'
export const UPDATE_NO_RESULT_MODAL = 'UPDATE_NO_RESULT_MODAL'
export const UPDATE_NO_RESULT_MESSAGE = 'UPDATE_NO_RESULT_MESSAGE'
